module.exports = __webpack_public_path__ + "img/10.6d841a0d.jpg";